// Sleeve manager — swap sleeves in/out of the (ghost) cash account.
// Account ghost toggle + per-sleeve link/unlink, active, mode (sim<->live),
// and contracts. ghost/live is account-level today; the per-sleeve mode +
// active live alongside the account ghost flag (per-sleeve ghost is a
// future enhancement — see the note in SleeveManagerCard).

import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { accounts as accountsApi } from "../api/endpoints";
import type { Account } from "../api/types";
import { AccountPicker } from "../components/AccountPicker";
import { SleeveManagerCard } from "../components/SleeveManagerCard";

export function SleevesPage() {
  const accountsQ = useQuery({
    queryKey: ["accounts"],
    queryFn: accountsApi.list,
    refetchInterval: 10_000,
  });

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const list = accountsQ.data ?? [];
  const account: Account | undefined = useMemo(
    () => (selectedId !== null ? list.find((a) => a.id === selectedId) : list[0]),
    [list, selectedId],
  );

  if (accountsQ.isLoading) {
    return <div className="muted">loading accounts…</div>;
  }
  if (list.length === 0) {
    return (
      <div className="card">
        <h2>No account yet</h2>
        <p>
          You haven't created a cash account.{" "}
          <Link to="/setup">Run the setup flow</Link> to create one first.
        </p>
      </div>
    );
  }
  if (!account) {
    return <div className="muted">account not found</div>;
  }

  return (
    <>
      <div className="row wrap" style={{ marginBottom: 8, gap: 8 }}>
        <h3 style={{ margin: 0, fontSize: 13 }}>Sleeves — {account.name}</h3>
        <span className="muted small">#{account.id} · {account.broker}</span>
        <div className="spacer" />
        <AccountPicker accounts={list} selectedId={account.id} onSelect={setSelectedId} />
      </div>
      {/* <div className="muted small" style={{ marginBottom: 8 }}>
        Each sleeve runs on the selected account. Link a sleeve to a <span className="pill ghost" style={{ fontSize: 10 }}>Sim</span> account for simulated fills with live data; link to a cash account for real orders.
      </div> */}

      <SleeveManagerCard accountId={account.id} assetClass={account.asset_class} />
    </>
  );
}
